//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	props: ["type"],
	data: function data() {
		return {
			headers: ["Name", "Application Status", "Move-In Date", "City", "Email", "Phone"],
			fields: ["full_name", "status", "move_in_date", "city", "email", "phone"],
			approvalLoading: false,
			monthLoading: false,
			stageLoading: false,
			approvalChartData: [["Approved", 0], ["Declined", 0]],
			stageChartData: [["Pending", 0], ["Background", 0], ["Credit", 0]],
			chartOptions: {
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: false
						},
						showInLegend: true,
						colors: ['#2D83D8', '#30C193', '#FFE066']
					}
				}
			},
			monthlyChartData: [["Jan", 0], ["Feb", 0], ["Mar", 0], ["Apr", 0], ["May", 0], ["Jun", 0], ["Jul", 0], ["Aug", 0], ["Sep", 0], ["Oct", 0], ["Nov", 0], ["Dec", 0]],
			loading: true,
			// CURRENT PERSON FORMAT
			// {
			//   full_name: "Tracey Dugald",
			//   status: "Pending CC",
			//   email: "tdugald0@blog.com",
			//   phone: "537-147-3005",
			//   city: "Huangyan"
			// }
			persons: [],
			person: {},
			totalRecord: 0,
			convertToResidentRules: [{ model: 'person.first_name', rules: 'required | string' }, { model: 'person.move_in_date', rules: 'required | date' }, { model: 'person.email', rules: 'required | email' }, { model: 'person.unitId', rules: 'required' }, { model: 'person.unit_status', rules: 'validate_unit_status' }]
		};
	},
	created: function created() {
		Event.$on('updated-pending-applicants-list', this.getDashboardData);
		Event.$on('convert-pending-to-resident', this.convertToResident);
	},
	beforeDestroy: function beforeDestroy() {
		Event.$off('updated-pending-applicants-list');
		Event.$off('convert-pending-to-resident');
	},

	methods: {
		getDashboardData: function getDashboardData() {
			var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'withdrawn';


			var self = this;

			window.axios.get('/prototype/applicants/get-applicants-by-status/' + status).then(function (response) {

				var outputData = [];

				response.data.forEach(function (element, index) {

					var applicant = {
						id: element.id,
						applicantId: element.id,
						is_applicant: element.is_applicant,
						personId: element.person.id,
						propertyId: element.person.property ? element.person.property.id : '',
						property_name: element.person.property ? element.person.property.name : '',
						full_name: element.person.full_name,
						status: element.status,
						email: element.person.email,
						phone: element.person.phone,
						city: element.person.city,
						first_name: element.person.first_name,
						last_name: element.person.last_name,
						move_in_date: element.person.move_in_date === '0000-00-00' || element.person.move_in_date === null ? '' : moment(element.person.move_in_date).format("MM/DD/YYYY"),
						lease_start_date: moment(element.person.move_in_date).format("MM/DD/YYYY"),
						unitId: element.unit_id,
						unit_name: element.unit ? element.unit.name : '',
						actual_rent_amount: element.unit ? element.unit.market_rent_amount : '',
						prorated_rent: '',
						lease_expire_date: moment(element.person.move_in_date).subtract(1, 'days').add(1, 'years').format("MM/DD/YYYY"),
						unit_status: element.unit ? element.unit.status : '',
						contactPreference: '',
						rent_amount: element.unit ? element.unit.rent_amount : '',
						unit_amenities: element.unit && element.unit.amenities ? element.unit.amenities : '',
						residentId: !(element.status === 'suspended' || element.status === 'Moved In')
					};

					outputData.push(applicant);
				});

				self.persons = outputData;
				self.totalRecord = outputData.length;
			});
		},
		additionalAction: function additionalAction(item) {
			return item.status === 'pending' || item.status === 'active';
		},
		convertToResident: function convertToResident(item) {
			this.person = item;
			this.validator.setRules(this.convertToResidentRules).setCustomMessages({
				'person.first_name.required': 'Please finish filling out the Applicant\'s basic info via the Edit screen.',
				'person.move_in_date.required': 'Please supply a Move In date via the Edit screen.',
				'person.unitId.required': 'The Applicant must first select a Unit before converting to Resident.'
			}).validate();
			if (this.validator.fails()) {
				var errors = [];
				errors = this.validator.errorsBag;
				var msg = '';
				errors.forEach(function (error) {
					msg += error.message + '(' + error.model + ')' + '.';
				});
				this.$snotify.error(msg);
			} else {
				Event.$emit('convert-applicant', item);
			}
		}
	},
	mounted: function mounted() {
		this.$initValidator();
		var unitStatus = ['NTV - Available', 'Vacant - Not Leased'];
		if (this.validator) {
			this.validator.extend('validate_unit_status', function (value, arg) {
				return unitStatus.includes(value);
			}, 'This unit status must be either NTV - Available or Vacant - Not Leased');
		}
		this.getDashboardData();
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ApplicantDashboard.vue
// module id = 8i53
// module chunks = 0 1